export default "__VITE_ASSET__929bda83__"